import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose'
import ModalBody from '@hotmart/space-lib/dist/components/modalBody'
import ModalHeader from '@hotmart/space-lib/dist/components/modalHeader'
import Icon from '@hotmart/space-lib/dist/components/icon'
import { CommunitySurveyProps } from './communityModalSurvey.types'
import { CustomModal, CustomProgressBar } from './communityModalSurvey.styles'

const CommunityModalSurvey = ({
  show,
  onClose,
  children,
  progressBarValue,
  showHeader,
  showCloseButton
}: CommunitySurveyProps) => {
  return (
    <CustomModal show={show} onClose={onClose}>
      <ModalHeader className="_mx-4 _mt-3">
        {showHeader && (
          <div className="_d-flex _align-items-center _justify-content-between">
            <CustomProgressBar
              className="_w-full"
              progressValue={progressBarValue}
              data-test="progress-bar"
            />

            {showCloseButton && (
              <button
                className="_d-flex _cursor-pointer _border-0 _bg-transparent _ml-4"
                onClick={onClose}
                data-test="close-modal"
              >
                <Icon icon={faClose} className="_text-4 _text-gray-700" />
              </button>
            )}
          </div>
        )}
      </ModalHeader>
      <ModalBody className="_mx-4 _mb-3">{children}</ModalBody>
    </CustomModal>
  )
}

export default CommunityModalSurvey
